import _ from "i18n";

const initialState = {
  BLOG: {
    categories: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    types: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    themes: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    conditions: []
  },
  EVENT: {
    categories: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    types: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    conditions: []
  },
  MEDIA: {
    categories: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    types: {
      fetching: false,
      fetched: false,
      items: [
        { name: _("Image"), id: "IMAGE" },
        { name: _("Video"), id: "VIDEO" },
        { name: _("Document"), id: "DOCUMENT" },
        { name: _("Album"), id: "ALBUM" }
      ],
      error: null,
      nbResult: 0
    },
    conditions: []
  },
  EMAILING: {
    categories: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    types: {
      fetching: false,
      fetched: false,
      items: [],
      error: null,
      nbResult: 0
    },
    conditions: []
  }
};

export const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case `RESET_FILTERS`: {
      return initialState;
    }
    case `FETCH_BLOG_CATEGORIES_PENDING`: {
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          categories: {
            ...state.BLOG.categories,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_BLOG_CATEGORIES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          categories: {
            ...state.BLOG.categories,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_BLOG_CATEGORIES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          categories: {
            ...state.BLOG.categories,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_BLOG_TYPES_PENDING`: {
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          types: {
            ...state.BLOG.types,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_BLOG_TYPES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          types: {
            ...state.BLOG.types,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_BLOG_TYPES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          types: {
            ...state.BLOG.types,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_BLOG_THEMES_PENDING`: {
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          themes: {
            ...state.BLOG.themes,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_BLOG_THEMES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          themes: {
            ...state.BLOG.themes,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_BLOG_THEMES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        BLOG: {
          ...state.BLOG,
          themes: {
            ...state.BLOG.themes,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_MEDIA_CATEGORIES_PENDING`: {
      return {
        ...state,
        MEDIA: {
          ...state.MEDIA,
          categories: {
            ...state.MEDIA.categories,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_MEDIA_CATEGORIES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        MEDIA: {
          ...state.MEDIA,
          categories: {
            ...state.MEDIA.categories,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_MEDIA_CATEGORIES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        MEDIA: {
          ...state.MEDIA,
          categories: {
            ...state.MEDIA.categories,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_MEDIA_TYPES_PENDING`: {
      return {
        ...state,
        MEDIA: {
          ...state.MEDIA,
          types: {
            ...state.MEDIA.types,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_MEDIA_TYPES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        MEDIA: {
          ...state.MEDIA,
          types: {
            ...state.MEDIA.types,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_MEDIA_TYPES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        MEDIA: {
          ...state.MEDIA,
          types: {
            ...state.MEDIA.types,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_EVENT_CATEGORIES_PENDING`: {
      return {
        ...state,
        EVENT: {
          ...state.EVENT,
          categories: {
            ...state.EVENT.categories,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_EVENT_CATEGORIES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        EVENT: {
          ...state.EVENT,
          categories: {
            ...state.EVENT.categories,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_EVENT_CATEGORIES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        EVENT: {
          ...state.EVENT,
          categories: {
            ...state.EVENT.categories,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_EVENT_TYPES_PENDING`: {
      return {
        ...state,
        EVENT: {
          ...state.EVENT,
          types: {
            ...state.EVENT.types,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_EVENT_TYPES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        EVENT: {
          ...state.EVENT,
          types: {
            ...state.EVENT.types,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_EVENT_TYPES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        EVENT: {
          ...state.EVENT,
          types: {
            ...state.EVENT.types,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_EMAILING_CATEGORIES_PENDING`: {
      return {
        ...state,
        EMAILING: {
          ...state.EMAILING,
          categories: {
            ...state.EMAILING.categories,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_EMAILING_CATEGORIES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        EMAILING: {
          ...state.EMAILING,
          categories: {
            ...state.EMAILING.categories,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_EMAILING_CATEGORIES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        EMAILING: {
          ...state.EMAILING,
          categories: {
            ...state.EMAILING.categories,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }
    case `FETCH_EMAILING_TYPES_PENDING`: {
      return {
        ...state,
        EMAILING: {
          ...state.EMAILING,
          types: {
            ...state.EMAILING.types,
            fetched: false,
            fetching: true
          }
        }
      };
    }
    case `FETCH_EMAILING_TYPES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        EMAILING: {
          ...state.EMAILING,
          types: {
            ...state.EMAILING.types,
            fetching: false,
            fetched: true,
            error: null,
            items: data,
            nbResult: nbResult
          }
        }
      };
    }
    case `FETCH_EMAILING_TYPES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        EMAILING: {
          ...state.EMAILING,
          types: {
            ...state.EMAILING.types,
            fetching: false,
            error,
            items: [],
            nbResult: 0
          }
        }
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filter.js